import { useEffect } from 'react';
import { SITE } from '../data/site';

function setMeta(selector, attr, value) {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [key, val] = selector.replace(/[[\]']/g, '').split('=');
    el.setAttribute(key.replace('meta', '').trim() || 'name', val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

/**
 * Minimal head manager — title, description, canonical and the OG pair.
 * Keeps react-helmet out of the dependency tree.
 */
export default function Seo({ title, description, path = '' }) {
  useEffect(() => {
    const full = title ? `${title} · ${SITE.name}` : `${SITE.name} — Cafe, Bar & Restaurant`;
    document.title = full;

    setMeta("meta[name='description']", 'content', description || SITE.shortDescription);
    setMeta("meta[property='og:title']", 'content', full);
    setMeta("meta[property='og:description']", 'content', description || SITE.shortDescription);
    setMeta("meta[property='og:url']", 'content', `${SITE.url}${path}`);

    let link = document.head.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', `${SITE.url}${path}`);
  }, [title, description, path]);

  return null;
}
